import React from 'react';
import { Form, Input } from 'antd';
import AutoAddressInput from 'components/AutoAddressInput';
import StateSelect from 'components/form/StateSelect';
import OptLabel from '../OptLabel';
import s from '../../s.module.less';

type Props = {
    // 表单命名空间前缀，如 ['address'] / ['location'] / ['rendering','providers',i]
    ns: (string | number)[];
};

// ZIP+4 存 9 位纯数字，无连字符（接口约定 postalCode = "941032612"）
const normalizeZip = (v?: string) => (v || '').replace(/\D/g, '').slice(0, 9);

// 地址块（原型 addressBlock）：address1 / address2 均带自动补全，选中后输入框显示 street, city, state；
// 仅 address1 联动回填 city/state/zip，address2 不影响其它字段
export default function AddressBlock({ ns }: Props) {
    const form = Form.useFormInstance();
    const setField = (key: string, value: string) => form.setFieldValue([...ns, key], value);

    return (
        <>
            <Form.Item name={[...ns, 'address1']} label="Address line 1">
                <AutoAddressInput
                    size="large"
                    placeholder="Start typing your address"
                    displayFields={['street', 'city', 'state']}
                    onCityChange={(v) => setField('city', v)}
                    onStateChange={(v) => setField('state', v)}
                    onPostcodeChange={(v) => setField('postalCode', normalizeZip(v))}
                />
            </Form.Item>
            <Form.Item name={[...ns, 'address2']} label={<OptLabel>Address line 2</OptLabel>}>
                <AutoAddressInput
                    size="large"
                    placeholder="Start typing your address"
                    displayFields={['street', 'city', 'state']}
                />
            </Form.Item>
            <div className={s.wizRow}>
                <Form.Item name={[...ns, 'city']} label="City">
                    <Input size="large" placeholder="City" />
                </Form.Item>
                <Form.Item name={[...ns, 'state']} label="State">
                    <StateSelect size="large" placeholder="Select state" isShowValue />
                </Form.Item>
                <Form.Item name={[...ns, 'postalCode']} label="ZIP code" normalize={normalizeZip}>
                    <Input size="large" inputMode="numeric" maxLength={9} placeholder="e.g. 787461234" />
                </Form.Item>
            </div>
        </>
    );
}
